import axios from "axios";


const config = require("../services/config.json");

const http = axios.create({
  auth: {
    username: config.securityUsername,
    password: config.securityPassword,
  },
});

http.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.statusCodeValue >= 400 &&
    error.response.statusCodeValue < 500;

  if (!expectedError) {
    console.error(error);
    alert("An unexpected error occurred");
  }
  return Promise.reject(error);
});

export default http;
